import { Navigate, Outlet } from "react-router";
import { selectUser, selectUserToken } from "../../store/slices/auth";
import { useSelector } from "../../store/store";
import { useRefreshCurrentUser } from "../../hooks/useRefreshCurrentUser";

export const AdminRoute = () => {
  const userToken = useSelector(selectUserToken);
  const user = useSelector(selectUser);
  const isAuthenticated = user && userToken;
  const refresh = useRefreshCurrentUser();

  // A user stored before getting admin rights: wait for the fresh profile
  // before sending them away
  if (isAuthenticated && !user?.is_admin && refresh.isLoading) {
    return null;
  }

  if (!isAuthenticated || !user?.is_admin) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};
